import React, { useEffect, useState } from "react";
import API from "../services/api";
import Sidebar from "../components/Sidebar";
import { toast } from "react-toastify";

function Support() {
  const [tickets, setTickets] = useState([]);
  const [selectedTicket, setSelectedTicket] = useState(null);

  const [ticketForm, setTicketForm] = useState({
    category: "general",
    subject: "",
    description: "",
    priority: "medium",
    attachment: null
  });

  const [replyForm, setReplyForm] = useState({
    message: "",
    attachment: null
  });

  useEffect(() => {
    fetchTickets();
  }, []);

  const fetchTickets = async () => {
    try {
      const res = await API.get("/support");
      setTickets(res.data);
    } catch (err) {
      console.log(err);
      toast.error("Failed to load tickets");
    }
  };

  const handleTicketChange = (e) => {
    const { name, value, files } = e.target;

    setTicketForm({
      ...ticketForm,
      [name]: files ? files[0] : value
    });
  };

  const handleReplyChange = (e) => {
    const { name, value, files } = e.target;

    setReplyForm({
      ...replyForm,
      [name]: files ? files[0] : value
    });
  };

  const createTicket = async (e) => {
    e.preventDefault();

    try {
      const formData = new FormData();

      Object.keys(ticketForm).forEach((key) => {
        formData.append(key, ticketForm[key]);
      });

      await API.post("/support", formData);

      toast.success("Ticket created");

      setTicketForm({
        category: "general",
        subject: "",
        description: "",
        priority: "medium",
        attachment: null
      });

      fetchTickets();

    } catch (err) {
      console.log(err);
      toast.error("Failed to create ticket");
    }
  };

  const openTicket = async (id) => {
    try {
      const res = await API.get(`/support/${id}`);
      setSelectedTicket(res.data);
    } catch (err) {
      toast.error("Failed to load ticket");
    }
  };

  const sendReply = async () => {
    try {
      const formData = new FormData();

      formData.append("message", replyForm.message);

      if (replyForm.attachment) {
        formData.append(
          "attachment",
          replyForm.attachment
        );
      }

      await API.post(
        `/support/reply/${selectedTicket.ticket.id}`,
        formData
      );

      toast.success("Reply sent");

      setReplyForm({
        message: "",
        attachment: null
      });

      openTicket(selectedTicket.ticket.id);

    } catch (err) {
      toast.error("Reply failed");
    }
  };

  const closeTicket = async (id) => {
    try {
      await API.put(`/support/close/${id}`);

      toast.success("Ticket closed");

      fetchTickets();

      if (selectedTicket) {
        setSelectedTicket(null);
      }

    } catch (err) {
      toast.error("Failed to close ticket");
    }
  };

  return (
    <div className="dashboard-layout">
      <Sidebar />

      <div className="main-content p-4">
        <h2>🎫 Support Center</h2>

        {/* CREATE TICKET */}
        <div className="card shadow border-0 mt-4">
          <div className="card-body">
            <h4>Create Support Ticket</h4>

            <form
              onSubmit={createTicket}
              className="row g-3 mt-2"
            >
              <div className="col-md-3">
                <select
                  name="category"
                  className="form-select"
                  value={ticketForm.category}
                  onChange={handleTicketChange}
                >
                  <option value="technical">Technical</option>
                  <option value="weather">Weather</option>
                  <option value="ai">AI Recommendation</option>
                  <option value="photo">Photo Upload</option>
                  <option value="checklist">Checklist</option>
                  <option value="cycle">Cycle Tracking</option>
                  <option value="account">Account</option>
                  <option value="billing">Billing</option>
                  <option value="general">General</option>
                  <option value="other">Other</option>
                </select>
              </div>

              <div className="col-md-3">
                <input
                  type="text"
                  name="subject"
                  className="form-control"
                  placeholder="Subject"
                  value={ticketForm.subject}
                  onChange={handleTicketChange}
                  required
                />
              </div>

              <div className="col-md-3">
                <select
                  name="priority"
                  className="form-select"
                  value={ticketForm.priority}
                  onChange={handleTicketChange}
                >
                  <option value="low">Low</option>
                  <option value="medium">Medium</option>
                  <option value="high">High</option>
                  <option value="urgent">Urgent</option>
                </select>
              </div>

              <div className="col-md-3">
                <input
                  type="file"
                  name="attachment"
                  className="form-control"
                  onChange={handleTicketChange}
                />
              </div>

              <div className="col-12">
                <textarea
                  name="description"
                  className="form-control"
                  rows="4"
                  placeholder="Describe your issue"
                  value={ticketForm.description}
                  onChange={handleTicketChange}
                  required
                />
              </div>

              <div className="col-12">
                <button className="btn btn-success">
                  Create Ticket
                </button>
              </div>
            </form>
          </div>
        </div>

        {/* TICKET LIST */}
        <div className="card shadow border-0 mt-4">
          <div className="card-body">
            <h4>My Tickets</h4>

            <div className="table-responsive mt-3">
              <table className="table table-bordered">
                <thead className="table-success">
                  <tr>
                    <th>Subject</th>
                    <th>Category</th>
                    <th>Priority</th>
                    <th>Status</th>
                    <th>Actions</th>
                  </tr>
                </thead>

                <tbody>
                  {tickets.map((ticket) => (
                    <tr key={ticket.id}>
                      <td>{ticket.subject}</td>
                      <td>{ticket.category}</td>
                      <td>{ticket.priority}</td>
                      <td>{ticket.status}</td>

                      <td>
                        <button
                          className="btn btn-primary btn-sm me-2"
                          onClick={() => openTicket(ticket.id)}
                        >
                          View
                        </button>

                        {ticket.status !== "closed" && (
                          <button
                            className="btn btn-danger btn-sm"
                            onClick={() =>
                              closeTicket(ticket.id)
                            }
                          >
                            Close
                          </button>
                        )}
                      </td>
                    </tr>
                  ))}
                </tbody>

              </table>
            </div>
          </div>
        </div>

        {/* TICKET MODAL */}
        {selectedTicket && (
          <div
            className="modal d-block"
            style={{
              background:
                "rgba(0,0,0,0.6)"
            }}
          >
            <div className="modal-dialog modal-lg">
              <div className="modal-content">

                <div className="modal-header">
                  <h5>
                    {selectedTicket.ticket.subject}
                  </h5>

                  <button
                    className="btn-close"
                    onClick={() =>
                      setSelectedTicket(null)
                    }
                  />
                </div>

                <div className="modal-body">
                  <p>
                    {selectedTicket.ticket.description}
                  </p>

                  <hr />

                  <h6>Conversation</h6>

                  {selectedTicket.replies.map((reply) => (
                    <div
                      key={reply.id}
                      className={`p-3 rounded mb-2 ${
                        reply.sender_type === "farmer"
                          ? "bg-light"
                          : "bg-success text-white"
                      }`}
                    >
                      <strong>
                        {reply.sender_type}
                      </strong>

                      <p className="mb-0">
                        {reply.message}
                      </p>
                    </div>
                  ))}

                  {selectedTicket.ticket.status !==
                    "closed" && (
                    <>
                      <hr />

                      <textarea
                        className="form-control"
                        rows="3"
                        name="message"
                        placeholder="Reply..."
                        value={replyForm.message}
                        onChange={handleReplyChange}
                      />

                      <input
                        type="file"
                        name="attachment"
                        className="form-control mt-2"
                        onChange={handleReplyChange}
                      />

                      <button
                        className="btn btn-success mt-3"
                        onClick={sendReply}
                      >
                        Send Reply
                      </button>
                    </>
                  )}
                </div>

              </div>
            </div>
          </div>
        )}

      </div>
    </div>
  );
}

export default Support;